import React, { useEffect, useState } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem('cookie_consent_accepted');
      if (!accepted) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem('cookie_consent_accepted', '1'); } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-8 md:bottom-8 z-50">
      <div className="bg-background border p-4 rounded-lg shadow-lg flex items-center gap-4">
        <div className="flex-1 text-sm text-muted-foreground">
          We use cookies to improve your experience. By continuing, you agree to our use of cookies.
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => setVisible(false)} className="px-3 py-1 rounded-md bg-muted/20">Decline</button>
          <button onClick={accept} className="px-3 py-1 rounded-md bg-primary text-primary-foreground">Accept</button>
        </div>
      </div>
    </div>
  );
}
